import { Translations } from '@ts-types/Translations'

const globalTranslations: Translations = {
  es: {
    seo_title: 'Centro de ayuda de wicadu',
    seo_description:
      'Descubre respuestas rápidas y útiles, tutoriales y consejos para aprovechar al máximo tu experiencia en wicadu',
    seo_keywords:
      'wicadu ayuda, soporte wicadu, stores, wicadu stores, pos, comercio electrónico, ayuda, ayuda tienda en línea, soporte plataforma e-commerce, preguntas frecuentes wicadu, guías de usuario, solución de problemas wicadu, centro de ayuda e-commerce, documentación wicadu, soporte al cliente wicadu, asistencia gestión tienda, preguntas frecuentes tienda en línea, tutoriales e-commerce',
    welcome_message: 'Hola, ¿cómo podemos ayudarte?',
    topics_title: 'Temas',
    trending_title: 'Artículos populares',
    suggested_title: 'Artículos recomendados',
    faq_title: 'Preguntas frecuentes',
  },
  en: {
    seo_title: 'wicadu Help Center',
    seo_description:
      'Discover quick and helpful faq, tutorials, and tips to make the most of your wicadu experience',
    seo_keywords:
      'wicadu help, stores, wicadu stores, pos, e-commerce, help, wicadu support, online store help, e-commerce platform support, wicadu FAQs, user guides, troubleshooting wicadu, e-commerce help center, wicadu documentation, wicadu customer support, store management assistance, online store FAQs',
    welcome_message: 'Hi. How can we help?',
    topics_title: 'Topics',
    trending_title: 'Trending Articles',
    suggested_title: 'Recommended Articles',
    faq_title: 'Frequently Asked Questions',
  },
  fr: {
    seo_title: "Centre d'aide wicadu",
    seo_description:
      "Découvrez des réponses rapides et utiles, des tutoriels et des conseils pour tirer le meilleur parti de votre expérience wicadu.",
    seo_keywords:
      "aide wicadu, support wicadu, stores, wicadu stores, pos, e-commerce, aide boutique en ligne, support plateforme e-commerce, FAQ wicadu, guides d'utilisation, dépannage wicadu, centre d'aide e-commerce, documentation wicadu, assistance client wicadu, aide gestion de boutique",
    welcome_message: 'Bonjour. Comment pouvons-nous vous aider ?',
    topics_title: 'Sujets',
    trending_title: 'Articles populaires',
    suggested_title: 'Articles recommandés',
    faq_title: 'Questions fréquentes',
  },
  pt: {},
}


export default globalTranslations
